var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab"},_vm._l((_vm.data),function(item,index){return _c('span',{key:index,class:_vm.tabval === item.num ? 'setectBg' : '',on:{"click":function($event){return _vm.change(item, index)}}},[_vm._v(_vm._s(item.name))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }